<template>
  <input
    :type="type"
    class="border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150"
    v-bind:class="{ 'border-red-500': error, 'bg-gray-300': disabled }"
    v-model="localValue"
    :disabled="disabled"
    :placeholder="placeholder"
    :maxlength="maxLength"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: {
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 10000,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/Form/Input.vue